module.exports = __webpack_public_path__ + "static/media/logo.9ad1d831.png";